module.exports = __webpack_public_path__ + "static/media/logo.c9f4fb42.png";